import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {PhotosState} from '@/store/types'
import axios from 'axios'

type PhotosGetter = GetterTree<PhotosState, any>
type PhotosMutation = MutationTree<PhotosState>
type PhotosAction = ActionTree<PhotosState, any>

const state: PhotosState = {
  photos: [],
}

const getters: PhotosGetter = {
  photos: (state) => state.photos,
}

const mutations: PhotosMutation = {
  setPhotos: (state, photos) => {
    state.photos = photos
  },
  addPhoto: (state, photo) => {
    state.photos = [...state.photos, photo]
  },
  removePhoto: (state, id) => {
    state.photos = state.photos.filter((p) => p.id !== id)
  },
}

const actions: PhotosAction = {
  addNewPhoto: ({commit, dispatch, rootState}, payload) => {
    const file = payload[0]
    const formData = new FormData()
    formData.append('photo', file)

    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent: any) => {
          dispatch('calculateProgress', {file, loaded: progressEvent.loaded})
        },
      }

      axios.post(`surveys/${rootState.tasks.task.id}/photos`, formData, config)
        .then((response) => {
          resolve(response.data.data)
          commit('addPhoto', response.data.data)
          dispatch('syncTaskPhotos')
          commit('setProgress', 0)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  deletePhoto: ({commit, dispatch}, {id}) => {
    commit('setLoader', true)
    return new Promise((resolve, reject) => {
      axios.delete(`assets/${id}`)
      .then((response) => {
        resolve([])
        commit('removePhoto', id)
        dispatch('syncTaskPhotos')
        commit('setLoader', false)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
